import React from "react";
import { enquireScreen } from "enquire-js";
import "./header.less";
import logo from "../../assets/imgs/homeTitleImg.png";
import { Menu,Icon, Popover } from "antd";

let isMobile = false;
enquireScreen((b) => {
  isMobile = b;
});

class Header extends React.PureComponent {
  state = {
    isMobile,
    showShadow: false,
    activeHome: false,
    activeProduct: false,
    activefaq: false,
    isScroll: false,
    menuVisible: false
  };

  componentDidMount() {
    enquireScreen((b) => {
      this.setState({
        isMobile: !!b,
      });
    });

  }


  navToShadow = (e) => {
    this.setState({ showShadow: e.mode === "leave" });
  };
  jumpToSection = (id) => {
    let element = document.getElementById(id);
    if (element) {
      // 64 header高度
      window.scrollTo(0, element.offsetTop - 64);
    }
  };

  handleDetail = (path) => {
    window.location.href = path
  }

  handleShowMenu = () => {
    this.setState({menuVisible: !this.state.menuVisible})
  }

  handleMenuClick = (event) => {
    this.setState({ menuVisible: false });
    this.handleDetail(event.key)
  };

  render() {

    const {location: {pathname}, isBgWhite} = this.props
    const {menuVisible} = this.state
    let menuList = [
        {
            label: 'Inicio',
            path: '/'
        },
        {
            label: 'Aviso de Privacidad',
            path: '/politica'
        },
        {
            label: 'Contrato de Servicio',
            path: '/terminos'
        },
    ]

    let renderInfo = () => {
        return menuList.map(item=> {
            return <div key={item.path} onClick={()=>this.handleDetail(item.path)} className={['menuItem', 'menuRight', pathname === item.path && 'menuCurrent'].join(' ')}>{item.label}</div>
        })
    }

    const menu = (
      <Menu
        mode="inline"
        id="nav"
        key="nav"
        onClick={(e) => this.handleMenuClick(e)}
        defaultSelectedKeys={[pathname]}
      >
        {
            menuList.map(item=> {
            return <Menu.Item key={item.path} >{item.label}</Menu.Item>
        })
        }
      </Menu>
    );
    return (
    <div className={[this.state.isMobile ? 'homeHeaderMob' : "homeHeader",  (pathname === '/' && !isBgWhite) && 'headerDesign'].join(' ')}>
        <img alt="logo" className={`logo`} src={logo} />
        {!isMobile ? <div className='menu'>
            {renderInfo()}
        </div>
        :
        <Popover
              overlayClassName="popover-menu"
              placement="bottomRight"
              content={menu}
              trigger="click"
              visible={menuVisible}
              arrowPointAtCenter
              onVisibleChange={this.handleShowMenu}
            >
              <Icon className="menuIcon" type="bars" onClick={this.handleShowMenu}/>
            </Popover>
        }
    </div>
    );
  }
}
export default Header;
